import {
  HorizontalTabs,
  HorizontalTabsButton,
  HorizontalTabsList,
  HorizontalTabsPanel,
} from '@cinch-labs/design-system'
import { TrackingEvent, useAnalytics } from '@cinch-nx/shared-analytics'
import cx from 'classnames'

import styles from './tabs.module.css'

interface TabProps {
  label: string
  trackingEvent: TrackingEvent
  panelContent: React.ReactNode
}

interface TabsProps {
  ariaLabel: string
  tabs: TabProps[]
}

export const Tabs: React.FC<TabsProps> = ({ ariaLabel, tabs }) => {
  const { trackEvent } = useAnalytics()

  return (
    <HorizontalTabs activeTabId="tab-1" className={styles.tabsList}>
      <HorizontalTabsList
        ariaLabel={ariaLabel}
        className={styles.tabButtonList}
      >
        {tabs.map((tab, index) => {
          const tabOrderNumber = index + 1

          const handleClick = () => {
            trackEvent(tab.trackingEvent)
          }

          return (
            <HorizontalTabsButton
              key={`tab-${tabOrderNumber}`}
              id={`tab-${tabOrderNumber}`}
              panelId={`tabpanel-${tabOrderNumber}`}
              className={cx(styles.tabButton, {
                [styles.tabButtonLeft]: tabOrderNumber === 1,
                [styles.tabButtonRight]: tabOrderNumber === 2,
              })}
              onButtonClick={() => handleClick()}
            >
              {tab.label}
            </HorizontalTabsButton>
          )
        })}
      </HorizontalTabsList>
      {tabs.map((tab, index) => {
        const tabOrderNumber = index + 1

        return (
          <HorizontalTabsPanel
            key={`tabpanel-${tabOrderNumber}`}
            id={`tabpanel-${tabOrderNumber}`}
            buttonId={`tab-${tabOrderNumber}`}
            className={styles.tabPanel}
          >
            {tab.panelContent}
          </HorizontalTabsPanel>
        )
      })}
    </HorizontalTabs>
  )
}
